import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
// import { HttpClientModule } from '@angular/common/http';
import { ButtonModule } from 'primeng/primeng';
import { CheckboxModule } from 'primeng/primeng';
// import {DataTableModule,SharedModule} from 'primeng/primeng';
import {InputTextModule} from 'primeng/primeng';
import {PasswordModule} from 'primeng/primeng';
import {DropdownModule} from 'primeng/primeng';
import {MultiSelectModule} from 'primeng/primeng';
import {PanelModule} from 'primeng/primeng';
// import {ToolbarModule} from 'primeng/primeng';
// import {CalendarModule} from 'primeng/primeng';
import {GrowlModule} from 'primeng/primeng';
import {InputSwitchModule} from 'primeng/primeng';
import {FileUploadModule} from 'primeng/primeng';


import { AuthGuard } from './auth.guard';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login/login.component';


import {AppRoutingModule} from './app-routing.module';

import { GlobalDataService } from './services/global-data.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MyInterceptor } from './utils/my-interceptor';




@NgModule({
  declarations: [
    AppComponent,
    LoginComponent
    ],
  imports: [
    BrowserModule,
    NoopAnimationsModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    ButtonModule,
    CheckboxModule,
    // DataTableModule,
    // SharedModule,
    InputTextModule,
    PasswordModule,
    DropdownModule,
    MultiSelectModule,
    // ToolbarModule,
    PanelModule,
    // CalendarModule,
    GrowlModule,
    InputSwitchModule,
    FileUploadModule,
    AppRoutingModule

    //Ng2SmartTableModule
  ],
  providers: [GlobalDataService, AuthGuard,{ provide: HTTP_INTERCEPTORS, useClass: MyInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/app.module.ts